const calculateDateDifference = (
  firstDate: string | number,
  secondDate: string | number,
): number => {
  const firstDateTime =
    typeof firstDate === 'string' ? new Date(firstDate).getTime() : firstDate;
  const secondDateTime =
    typeof secondDate === 'string'
      ? new Date(secondDate).getTime()
      : secondDate;

  return firstDateTime - secondDateTime;
};

const addToDate = (date: string, miliseconds: number): number =>
  new Date(date).getTime() + miliseconds;

const checkIfDateEqual = (firstDate: Date, secondDate: Date): boolean => {
  const isYearsEqual = firstDate.getFullYear() === secondDate.getFullYear();
  const isMonthEqual = firstDate.getMonth() === secondDate.getMonth();
  const isDateEqual = firstDate.getDate() === secondDate.getDate();

  return isYearsEqual && isMonthEqual && isDateEqual;
};

const checkIfUTCDateEqual = (firstDate: Date, secondDate: Date): boolean => {
  const isYearsEqual =
    firstDate.getUTCFullYear() === secondDate.getUTCFullYear();
  const isMonthEqual = firstDate.getUTCMonth() === secondDate.getUTCMonth();
  const isDateEqual = firstDate.getUTCDate() === secondDate.getUTCDate();

  return isYearsEqual && isMonthEqual && isDateEqual;
};

const getEndTimeFromNow = (miliseconds: number): string => {
  const now = Date.now();
  const endTime = now + miliseconds;

  return new Date(endTime).toISOString();
};

const calcTimeToEndFromNow = (endTime: string | number): number => {
  const endTimeMiliseconds =
    typeof endTime === 'string' ? new Date(endTime).getTime() : endTime;
  const now = Date.now();

  return endTimeMiliseconds - now;
};

const formatDateToEu = (date: string): string => {
  const formattedDate = new Date(date).toLocaleDateString('en-GB');

  return formattedDate.replace(/\//g, '.');
};

const isISOString = (value: string): boolean => {
  const date = new Date(value);

  return !isNaN(date.getTime()) && value === date.toISOString();
};

export {
  addToDate,
  calcTimeToEndFromNow,
  calculateDateDifference,
  checkIfDateEqual,
  checkIfUTCDateEqual,
  formatDateToEu,
  getEndTimeFromNow,
  isISOString,
};
